import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

const Anim = keyframes`
  0%, 40%, 100% { 
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  } 20% { 
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
`;

const Loader = styled.div`
  margin: 100px auto 0;
  width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;

  > div {
    background-color: var(--success);
    height: 100%;
    width: 8px;
    display: inline-block;

    animation: ${Anim} 1.2s infinite ease-in-out;
    :nth-of-type(2) {
      -webkit-animation-delay: -1.1s;
      animation-delay: -1.1s;
    }

    :nth-of-type(3) {
      -webkit-animation-delay: -1s;
      animation-delay: -1s;
    }

    :nth-of-type(4) {
      -webkit-animation-delay: -0.9s;
      animation-delay: -0.9s;
    }

    :nth-of-type(5) {
      -webkit-animation-delay: -0.8s;
      animation-delay: -0.8s;
    }
  }
`;

const TextWrapper = styled.div`
  text-align: center;
  align-content: center;
  color: var(--darkText);
`;

const Loading = () => (
  <>
    <Loader>
      <div />
      <div />
      <div />
      <div />
      <div />
    </Loader>
    <TextWrapper>
      <h4>Loading</h4>
    </TextWrapper>
  </>
);

export { Loading };
